<template>
    <Head><title>Details - User</title></Head>
    <h1 class="mb-8 text-3xl font-bold">
        <Link class="text-indigo-400 hover:text-indigo-600" href="/users">Users</Link>
        <span class="text-indigo-400 font-medium">/</span> Details
    </h1>
    <div class="bg-gray-100">
        <div class="container mx-auto my-5 p-5">
            <div class="md:flex no-wrap md:-mx-2 ">
                <div class="w-full md:w-3/12 md:mx-2">
                    <div class="bg-white p-3 border-t-4 border-green-400 mb-2">
                        <h1 class="text-gray-900 font-bold text-xl leading-8 my-1">{{ user.name }}</h1>
                        <ul
                            class="bg-gray-100 text-gray-600 hover:text-gray-700 hover:shadow py-2 px-3 mt-3 divide-y rounded shadow-sm">
                            <li class="flex items-center py-3">
                                <span>Status</span>
                                <span class="ml-auto"><span class="bg-green-500 py-1 px-2 rounded text-white text-sm">Active</span></span>
                            </li>
                            <li class="flex items-center py-3">
                                <span>total Projects</span>
                                <span class="ml-auto"><span
                                    class="bg-green-500 py-1 px-2 rounded text-white text-sm">{{
                                        user.projectsCount
                                    }}</span></span>
                            </li>
                            <li class="flex items-center py-3">
                                <span>Balance</span>
                                <span class="ml-auto">{{ user.balance }}</span>
                            </li>
                            <li class="flex items-center py-3">
                                <span>Phone</span>
                                <span class="ml-auto">{{ user.phone }}</span>
                            </li>
                            <li class="flex items-center py-3">
                                <span>Email</span>
                                <span class="ml-auto">{{ user.email }}</span>
                            </li>
                            <li class="flex items-center py-3">
                                <span>Member since</span>
                                <span class="ml-auto">{{ user.created_at }}</span>
                            </li>
                        </ul>
                    </div>
                    <div class="my-4"></div>
                    <div class="bg-white p-3 hover:shadow">
                        <div class="flex items-center space-x-3 font-semibold text-gray-900 text-xl leading-8">
                        <span class="text-green-500">
                            <svg class="h-5 fill-current" xmlns="http://www.w3.org/2000/svg" fill="none"
                                 viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                      d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"/>
                            </svg>
                        </span>
                            <span>Notifications and Requests</span>
                        </div>
                        <div class="grid">
                            <ul class="flex flex-col">
                                <li class="flex items-center py-3">
                                    <span>Projects Approval Requests</span>
                                    <span class="ml-auto">0</span>
                                </li>
                                <li class="flex items-center py-3">
                                    <span>Invites Sent</span>
                                    <span class="ml-auto">0</span>
                                </li>
                                <li class="flex items-center py-3">
                                    <span>Invites Accepted</span>
                                    <span class="ml-auto">0</span>
                                </li>
                                <li class="flex items-center py-3">
                                    <span>Favourites Projects</span>
                                    <span class="ml-auto">0</span>
                                </li>
                                <li class="flex items-center py-3">
                                    <span>Withdrawals </span>
                                    <span class="ml-auto">0</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <!-- Right Side -->
                <div class="w-full md:w-9/12 mx-2 h-64">
                    <!-- update Section -->
                    <div class="bg-white p-3 shadow-sm rounded-sm">
                        <div class="flex items-center space-x-2 font-semibold text-gray-900 leading-8">
                        <span class="text-green-500">
                            <svg class="h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                 stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                      d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
                            </svg>
                        </span>
                            <span class="tracking-wide">Update info</span>
                        </div>
                        <form @submit.prevent="update">
                            <div class="text-gray-700">
                                <div class="grid md:grid-cols-2 text-sm">

                                    <div class="grid grid-cols-2">
                                        <text-input v-model="form.name" :error="form.errors.name"
                                                    class="px-4 py-2 font-semibold" label="Name"/>
                                    </div>
                                    <div class="grid grid-cols-2">
                                        <text-input v-model="form.email" :error="form.errors.email"
                                                    class="px-4 py-2 font-semibold" label="Email"/>
                                    </div>
                                    <div class="grid grid-cols-2">
                                        <text-input v-model="form.phone" :error="form.errors.phone"
                                                    class="px-4 py-2 font-semibold" label="Phone Number"/>
                                    </div>
                                    <div class="grid grid-cols-2">
                                        <text-input v-model="form.settlement_number"
                                                    :error="form.errors.settlement_number"
                                                    class="px-4 py-2 font-semibold" label="Settlement Number"/>
                                    </div>
                                </div>

                            </div>
                            <div class="flex items-center px-8 py-4 border-t mt-4">
                                <button v-if="!user.deleted_at" class="text-red-600 hover:underline"
                                        tabindex="-1"
                                        type="button"
                                        @click="destroy">Delete User
                                </button>
                                <loading-button :loading="form.processing" class="btn-indigo ml-auto"
                                                type="submit">
                                    Update User
                                </loading-button>
                            </div>

                        </form>
                        <div>
                        </div>
                    </div>

                    <div class="my-4"></div>
                    <div class="bg-white p-3 shadow-sm rounded-sm">
                        <div class="grid ">
                            <div>
                                <div class="flex items-center space-x-2 font-semibold text-gray-900 leading-8 mb-3">
                                <span class="text-green-500">
                                    <svg class="h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/></svg>
                                </span>
                                    <span class="tracking-wide">Projects</span>
                                </div>
                                <div v-if="projects.length > 0">
                                    <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                                        <thead
                                            class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                                        <tr>
                                            <th scope="col" class="py-3 px-6">
                                                Name
                                            </th>
                                            <th scope="col" class="py-3 px-6">
                                                Type
                                            </th>
                                            <th scope="col" class="py-3 px-6">
                                                Cost
                                            </th>

                                            <th scope="col" class="py-3 px-6">
                                                Address
                                            </th>
                                            <th scope="col" class="py-3 px-6">
                                                Created At
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700"
                                            v-for="project in projects" :key="project.id">
                                            <th scope="row"
                                                class="py-4 px-6 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                                <Link :href="`/projects/details/${project.id}`">
                                                    {{ project.name }}
                                                </Link>

                                            </th>
                                            <th scope="row">
                                                {{ project.type }}
                                            </th>
                                            <th scope="row">
                                                {{ project.actual_budget }}
                                            </th>
                                            <th scope="row">
                                                {{ project.address }}
                                            </th>
                                            <th scope="row">
                                                {{ formatDate(project.created_at) }}
                                            </th>

                                        </tr>

                                        </tbody>
                                    </table>
                                </div>
                                <div v-else>
                                    <p
                                        class="block w-full text-blue-800 text-sm font-semibold rounded-lg hover:bg-gray-100 focus:outline-none focus:shadow-outline focus:bg-gray-100 hover:shadow-xs p-3 my-4">
                                        No Projects Data found
                                    </p>
                                </div>
                                <button
                                    class="block w-full text-blue-800 text-sm font-semibold rounded-lg hover:bg-gray-100 focus:outline-none focus:shadow-outline focus:bg-gray-100 hover:shadow-xs p-3 my-4"
                                >
                                    <a href="/projects">
                                        Show All Projects
                                    </a>

                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="my-4"></div>
                    <div class="bg-white p-3 shadow-sm rounded-sm">
                        <div class="grid ">
                            <div>
                                <div class="flex items-center space-x-2 font-semibold text-gray-900 leading-8 mb-3">
                                <span class="text-green-500">
                                    <svg class="h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                         stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round"
                                                                     stroke-width="2"
                                                                     d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
                                    </svg>
                                </span>
                                    <span class="tracking-wide">Latest Payments</span>
                                </div>
                                <div v-if="payments.length > 0">
                                    <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                                        <thead
                                            class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                                        <tr>
                                            <th scope="col" class="py-3 px-6">
                                                Reference
                                            </th>
                                            <th scope="col" class="py-3 px-6">
                                                Project
                                            </th>
                                            <th scope="col" class="py-3 px-6">
                                                Buyer Name
                                            </th>
                                            <th scope="col" class="py-3 px-6">
                                                Amount
                                            </th>
                                            <th scope="col" class="py-3 px-6">
                                                Date
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700"
                                            v-for="payment in payments" :key="payment.id">
                                            <th scope="row"
                                                class="py-4 px-6 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                                {{ payment.uuid }}
                                            </th>
                                            <th scope="row"
                                                class="py-4 px-6 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                                {{ payment.project.name }}
                                            </th>
                                            <th scope="row"
                                                class="py-4 px-6 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                                {{ payment.user.name }}
                                            </th>
                                            <th scope="row"
                                                class="py-4 px-6 ">
                                                {{ payment.amount }}
                                            </th>
                                            <th scope="row"
                                                class="py-4 px-6 ">
                                                {{ formatDate(payment.created_at) }}
                                            </th>
                                        </tr>
                                        </tbody>
                                    </table>

                                </div>
                                <div v-else>
                                    <p
                                        class="block w-full text-blue-800 text-sm font-semibold rounded-lg hover:bg-gray-100 focus:outline-none focus:shadow-outline focus:bg-gray-100 hover:shadow-xs p-3 my-4">
                                        No Payments Data found
                                    </p>
                                </div>

                                <button
                                    class="block w-full text-blue-800 text-sm font-semibold rounded-lg hover:bg-gray-100 focus:outline-none focus:shadow-outline focus:bg-gray-100 hover:shadow-xs p-3 my-4">
                                    <a href="/payments">
                                        Show All Payments
                                    </a>

                                </button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>

</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import FileInput from '@/Shared/FileInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
    components: {
        FileInput,
        Head,
        Link,
        LoadingButton,
        SelectInput,
        TextInput,
        TrashedMessage,
    },
    layout: Layout,
    props: {
        user: Object,
        projects: Array,
        payments: Array
    },
    remember: 'form',
    data() {
        return {
            form: this.$inertia.form({
                _method: 'put',
                name: this.user.name,
                phone: this.user.phone,
                settlement_number: this.user.settlement_number,
                email: this.user.email,
                password: '',
            }),
        }
    },
    methods: {
        update() {
            this.form.post(`/users/${this.user.id}`, {
                onSuccess: () => this.form.reset('password', 'photo'),
            })
        },
        destroy() {
            if (confirm('Are you sure you want to delete this user?')) {
                this.$inertia.delete(`/users/${this.user.id}`)
            }
        },
        restore() {
            if (confirm('Are you sure you want to restore this user?')) {
                this.$inertia.put(`/users/${this.user.id}/restore`)
            }
        },
        formatDate(value) {
            const date = new Date(value);

            return date.toLocaleString().toUpperCase();
        },
    },
}

</script>

